import React from "react";
import abt from "../../assets/images/aboutus.png";
import "./Aboutussec.css";

function Aboutussec() {
  return (
    <div className="abt-container">
      <div className="abt-content">
        <div className="abt-text">
          <div className="abt-text-head">About Us</div>
          <div className="abt-text-desc">
            <p className="abt-text-desc-upper">
              RisoApp is a next-generation, AI-powered counseling platform
              designed to guide individuals through every stage of their
              education and career journey. By seamlessly blending expert human
              guidance with intelligent technology, we deliver highly
              personalized support that helps users:
            </p>
            <ul className="abt-text-desc-bullet">
              <li>Discover their unique strengths</li>
              <li>Make informed and confident career decisions</li>
              <li>
                Set and achieve meaningful personal and professional goals
              </li>
            </ul>
            <p className="abt-text-desc-lower">
              Whether you're a student, job seeker, or working professional,
              RisoApp empowers you to unlock your full potential.
            </p>
          </div>
        </div>
        <div className="abt-img">
          <img src={abt} alt="job" />
        </div>
      </div>
    </div>
  );
}

export default Aboutussec;
